import { useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useNewChatTrigger } from './useNewChatTrigger';
import { useArtifactsReset } from './useArtifactsReset';
import { usePinboardReset } from './usePinboardReset';
import { HISTORY } from '../constants/constant';
import { RESET_NAVIGATION_TO_HOME } from '../actions/app.type';

export const useSmartNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { triggerNewChat } = useNewChatTrigger();
  const { triggerArtifactsReset } = useArtifactsReset();
  const { triggerPinboardReset } = usePinboardReset();

  const handleNavigation = useCallback((navItem: any, isNavigating: boolean) => {
    // Guard against SideNavigation firing onSelect with empty data when selectedItem prop changes
    if (!navItem?.id) return
    // Prevent navigation if we're currently navigating from ChatHistory
    if(navItem?.id?.toLowerCase() === HISTORY) return
    if (!isNavigating) {
      // Reset any overridden active menu so URL-based selection takes over
      dispatch({ type: RESET_NAVIGATION_TO_HOME });
      // Special handling for + icon when already on chat page
      if (navItem?.id === 'newChat' && navItem.path === '/chat' && location.pathname === '/chat') {
        triggerNewChat();
      } else if (navItem?.id === 'artifacts' && navItem.path === '/artifacts' && location.pathname === '/artifacts') {
        // Opening an artifact keeps the same route, so navigate() can't bring the
        // list back — ask the artifacts screen to reset itself instead.
        triggerArtifactsReset();
      } else if (navItem?.id === 'pinboard' && navItem.path === '/studio' && location.pathname === '/studio') {
        // Opening a board keeps the same route, so navigate() can't bring the
        // list back — ask the pinboard screen to reset itself instead.
        triggerPinboardReset();
      } else {
        navigate(navItem.path);
      }
    }
  }, [navigate, location.pathname, triggerNewChat, triggerArtifactsReset, triggerPinboardReset, dispatch]);

  return { handleNavigation };
};
